import React, { Component } from "react";
import { connect } from "react-redux";

import "./styles/Home.css";

import HomeFeedSkeleton from "../components/HomeFeedSkeleton";
import AdList from "../components/AdList";
import AdMenu from "../components/AdMenu";
import SummaryByCountry from "../components/SummaryByCountry";
import Footer from "../components/Footer";
import WantedSearchEmpty from "../components/WantedSearchEmpty";

class AdSearch extends Component {
  componentWillUnmount() { }

  render() {
    const { loading, adList, pageCount, query, user_id, token } = this.props;
    const isLoggedIn = Boolean(user_id && token);
    const showEmpty = !loading && pageCount === 0;

    return (
      <React.Fragment>
        <div className="Home-in">
          <div className="col-lg-3 d-none d-lg-block">
            <div className="Home-left">
              <AdMenu />
              {isLoggedIn && <SummaryByCountry />}
            </div>
          </div>
          <div className="col-lg-9">
            {loading ? (
              <HomeFeedSkeleton count={8} />
            ) : showEmpty && isLoggedIn ? (
              <WantedSearchEmpty query={query} />
            ) : (
              <AdList adList={adList} />
            )}
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    adList: reducer.adSearch.list,
    pageCount: reducer.adSearch.page_count,
    query: reducer.adSearch.query,
    error: reducer.adSearch.error,
    loading: reducer.adSearch.loading,
  };
}

export default connect(mapStateToProps, null)(AdSearch);
